import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgBiospecimen = (props) => /* @__PURE__ */ _jsx("svg", {
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M6 2a1 1 0 0 0 0 2h1v13a5 5 0 1 0 10 0V4h1a1 1 0 0 0 0-2H6Zm3 5V4h6v3H9Zm4.708 5.708a1 1 0 1 1-1.414-1.414 1 1 0 0 1 1.414 1.414Zm-3.414 4a1 1 0 1 0 1.414-1.414 1 1 0 1 0-1.415 1.413l.001.001Z",
		fill: "currentColor"
	})
});
export default SvgBiospecimen;
